import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  IconButton,
  InputAdornment,
  Link,
  TextField,
  Typography,
} from '@mui/material';
import { Person, Visibility, VisibilityOff } from '@mui/icons-material';
import { RootState } from '../../redux/store';
import { useAppDispatch } from '../../redux/hooks';
import { login, clearError } from '../../redux/slices/userSlice';
import Container from '../../components/LandingPage/Container';

const Hero: React.FC = () => {
  const [credential, setCredential] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  const dispatch = useAppDispatch();
  const { loading, error } = useSelector((state: RootState) => state.user);
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(clearError());
  }, [dispatch]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      await dispatch(login({ username: credential, password }));

      const token = localStorage.getItem('token');
      if (token) {
        const userString = localStorage.getItem('user');

        if (userString) {
          try {
            const userData = JSON.parse(userString);
            if (userData.role === 'admin') {
              navigate('/admin');
            } else {
              navigate('/');
            }
          } catch (err) {
            console.log(err);
            navigate('/');
          }
        } else {
          navigate('/');
        }
      }
    } catch (err) {
      console.error('Login failed:', err);
    }
  };
  return (
    <Box
      sx={{
        background:
          'radial-gradient(circle at center, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.6) 35%, rgba(0, 0, 0, 0.0) 70%), linear-gradient(90deg, rgb(20, 20, 20) 0%, rgba(20, 20, 20, 0.85) 35%, rgba(217, 217, 217, 0) 65%), linear-gradient(270deg, rgb(20, 20, 20) 0%, rgba(20, 20, 20, 0.85) 35%, rgba(217, 217, 217, 0) 65%), url(/images/landing-page-hero.png)',
        backgroundRepeat: 'no-repeat, no-repeat, no-repeat, no-repeat',
        backgroundPosition: 'center center, left center, right center, center center',
        backgroundSize: 'cover, 50% 100%, 50% 100%, cover',
      }}
      id="login"
    >
      <Container>
        <Box
          display="flex"
          flexDirection={{ xs: 'column', md: 'row' }}
          justifyContent="space-between"
          width="100%"
        >
          <Box
            display="flex"
            flexDirection="column"
            gap="18px"
            width={{ xs: '100%', md: '561px' }}
            padding={{ xs: '48px 0 32px 0', md: '90px 0 70px 0' }}
          >
            <Typography color="white" fontSize="42px" fontWeight="400" lineHeight="52px">
              Venda tecnologia de forma inteligente, sem complicação.
            </Typography>
            <Typography
              color="white"
              fontSize="21px"
              fontWeight="400"
              lineHeight="31px"
              letterSpacing="0.666px"
            >
              Transforme sua revenda com um modelo digital, eficiente e lucrativo sem se preocupar
              com estoque, entrega ou impostos.
            </Typography>
            <Typography
              color="white"
              fontSize="21px"
              fontWeight="700"
              lineHeight="31px"
              letterSpacing="0.666px"
            >
              Mais facilidade, mais vendas, mais lucratividade.
            </Typography>
            {/* <Box display="flex" margin={{ xs: '0 auto', md: '0' }} width={{ xs: '100%', md: '118px' }}>
              <Button
                variant="contained"
                color="primary"
                sx={{
                  width: '100%',
                  fontWeight: '500',
                  color: 'white',
                  '&:hover': { backgroundColor: 'var(--acer-green)', color: 'white' },
                }}
              >
                <Typography>Saiba mais</Typography>
              </Button>
            </Box> */}
          </Box>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            padding="47px 0 42px 0"
            width={{ xs: '100%', md: '417px' }}
            margin={{ xs: '0 auto', md: '0' }}
          >
            <Box
              component="form"
              onSubmit={handleSubmit}
              display="flex"
              width="100%"
              gap="27px"
              flexDirection="column"
              padding="23px 14px 23px 14px"
              bgcolor="white"
              borderRadius="8px"
            >
              <Box display="flex" flexDirection="column" gap="16px">
                {error && (
                  <Typography color="error" fontSize="14px">
                    {error}
                  </Typography>
                )}
                <TextField
                  fullWidth
                  placeholder="Digite seu e-mail ou CNPJ"
                  value={credential}
                  onChange={e => setCredential(e.target.value)}
                  required
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Person sx={{ color: 'var(--acer-green)' }} />
                      </InputAdornment>
                    ),
                    sx: { height: '45px' },
                    inputProps: { style: { fontSize: '15px' } },
                  }}
                />
                <TextField
                  fullWidth
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Digite sua senha"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  required
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                          {showPassword ? (
                            <VisibilityOff sx={{ color: 'var(--acer-green)' }} />
                          ) : (
                            <Visibility sx={{ color: 'var(--acer-green)' }} />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                    sx: { height: '45px' },
                    inputProps: { style: { fontSize: '15px' } },
                  }}
                />
                <Box display="flex" justifyContent="end">
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={rememberMe}
                        onChange={e => setRememberMe(e.target.checked)}
                        sx={{
                          color: 'var(--acer-gray)',
                          '&.Mui-checked': {
                            color: 'var(--acer-green)',
                          },
                        }}
                      />
                    }
                    label={
                      <Typography fontSize="14px" color="var(--acer-mediumgray)">
                        Lembrar-me neste dispositivo
                      </Typography>
                    }
                  />
                </Box>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={loading}
                  sx={{
                    width: '100%',
                    fontWeight: '500',
                    color: 'white',
                    '&:hover': { backgroundColor: 'var(--acer-green)', color: 'white' },
                  }}
                >
                  <Typography>{loading ? 'Entrando...' : 'Entrar'}</Typography>
                </Button>
                <Typography
                  fontSize="16px"
                  fontWeight="400"
                  lineHeight="24px"
                  letterSpacing="0.15px"
                  textAlign="center"
                >
                  Esqueceu sua senha?{' '}
                  <Link
                    href="#"
                    onClick={e => {
                      e.preventDefault();
                      navigate('/forgot-password');
                    }}
                  >
                    Clique aqui para recuperar
                  </Link>
                </Typography>
              </Box>
              <Box
                display="flex"
                flexDirection="column"
                gap="16px"
                justifyContent="center"
                alignItems="center"
              >
                <Typography
                  fontSize="16px"
                  fontWeight="500"
                  lineHeight="24px"
                  letterSpacing="0.15px"
                >
                  Ainda não tem uma conta?
                </Typography>
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: 'var(--acer-dark)',
                    width: '100%',
                    fontWeight: '500',
                    color: 'white',
                    '&:hover': { backgroundColor: 'var(--acer-mediumgray)', color: 'white' },
                  }}
                  onClick={() => navigate('/register')}
                >
                  <Typography>Solicitar Acesso</Typography>
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Hero;
